import { render, staticRenderFns } from "./ordertask.vue?vue&type=template&id=69b7d54e&scoped=true"
import script from "./ordertask.vue?vue&type=script&lang=js"
export * from "./ordertask.vue?vue&type=script&lang=js"
import style0 from "./ordertask.vue?vue&type=style&index=0&id=69b7d54e&prod&scoped=true&lang=css"
import style1 from "./ordertask.vue?vue&type=style&index=1&id=69b7d54e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7d54e",
  null
  
)

export default component.exports